import React from "react";

import classNames from "classnames";

import { Tooltip } from "components/Common/clearsense-ui/components";

import { COLUMN_DATA, FLAGS } from "./constants";

const Table = ({
  data,
  nestedLevel = 0,
  isLastChild = [],
  setActiveTab,
  elementIds,
}) => {
  const cell = (content, className, id, isFirstColumn) => (
    <div
      className={classNames(
        "bg-white dark:bg-cs-ui-gray-800 dark:text-shade-light p-2 border-b border-r",
        className
      )}
    >
      <span
        className={classNames({
          "cursor-pointer text-primary-shade dark:text-primary-lighter":
            isFirstColumn,
        })}
        onClick={() =>
          elementIds.includes(id) &&
          setActiveTab({ tab: "description", id: id })
        }
      >
        {content}
      </span>
    </div>
  );

  const flags = datum => (
    <div className="flex space-x-2">
      {Object.entries(FLAGS).map(
        ([flag, flagData]) =>
          datum[`${flag}`] && (
            <Tooltip content={flagData.tooltip} position="top">
              {flagData.content}
            </Tooltip>
          )
      )}
    </div>
  );

  const hasManyTypes = datum =>
    datum.id.split("").reverse().join("").slice(0, 3) === "]x[";

  const getTypes = datum =>
    datum.type.map(type => ({
      id: `${datum.id.replace("[x]", "")}${type.code}`,
      type: [{ code: `${type?.code}` }],
    }));

  const getCardinality = datum =>
    datum.min || datum.max ? `${datum.min}..${datum.max}` : "";

  return data.map((datum, childPosition) => (
    <>
      <div className="flex w-full" key={datum.id}>
        {nestedLevel !== 0 &&
          Array(nestedLevel)
            .fill()
            .map((_, i) => (
              <div
                className={`flex flex-col h-max`}
                style={{ minWidth: "25px" }}
                key={i}
              >
                <div className="flex flex-1 w-full">
                  <div className={`w-1/2  border-gray-400`}>&nbsp;</div>
                  <div
                    className={classNames("w-1/2 border-gray-400", {
                      "border-l-2":
                        i + 1 === nestedLevel || !isLastChild[i + 1],
                      "border-b-2": i + 1 === nestedLevel,
                    })}
                  >
                    &nbsp;
                  </div>
                </div>
                <div className="flex flex-1 w-full">
                  <div className={`w-1/2 border-gray-400`}>&nbsp;</div>
                  <div
                    className={classNames("w-1/2 border-gray-400", {
                      "border-l-2":
                        (i + 1 === nestedLevel &&
                          childPosition !== data.length - 1) ||
                        (i + 1 !== nestedLevel && !isLastChild[i + 1]),
                    })}
                  >
                    &nbsp;
                  </div>
                </div>
              </div>
            ))}
        {cell(
          datum.id.split(".").pop(),
          `${COLUMN_DATA[0].className}`,
          datum.id,
          true
        )}
        {cell(flags(datum), COLUMN_DATA[1].className)}
        {cell(getCardinality(datum), COLUMN_DATA[2].className)}
        {cell(
          datum.type?.[0]?.code.split(".")[2] ||
            datum.type?.[0]?.code ||
            datum.id,
          COLUMN_DATA[3].className
        )}
        {cell(datum.short, COLUMN_DATA[4].className)}
      </div>
      {(datum.children || hasManyTypes(datum)) && (
        <Table
          data={hasManyTypes(datum) ? getTypes(datum) : datum.children}
          nestedLevel={nestedLevel + 1}
          isLastChild={[...isLastChild, data.length === childPosition + 1]}
          setActiveTab={setActiveTab}
          elementIds={elementIds}
        />
      )}
    </>
  ));
};

export default Table;
